import * as React from 'react';
import { FC, PropsWithChildren } from 'react';
import styles from './floating-action-button.module.sass';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

export interface FloatingActionButtonProps {
    callback: () => void;
    buttonContent: React.ReactElement;
    tooltipText?: string;
}

export const FloatingActionButton: FC<PropsWithChildren<FloatingActionButtonProps>> = (props) => {

    const button = () => <Button onClick={props.callback} className={styles.floatingActionButton}>
        {props.buttonContent}
    </Button>;

    return (
        <div className={styles.floatingActionWrapper}> {
            props.tooltipText ? <OverlayTrigger
                    trigger={['hover', 'focus']}
                    placement="top"
                    overlay={<Tooltip>{props.tooltipText}</Tooltip>}
                    key={'btnDeletePlayerAll'}
                    rootClose={true}>
                    {button()}
                </OverlayTrigger>
                : button()
        }
        </div>
    );
};

